import ReactMarkdown from "react-markdown";

import type { Question } from "@frontierx/shared/schemas/Question";
import { CheckCircle, MessageCircleQuestion, Sparkles } from "lucide-react";

import { Button } from "@/components/ui/button";

import type { AiHelp } from "../Help/AiHelpBrowser";
import type { HandleGetHelpFunction } from "../Help/AiHelpCard";

export interface QuestionItemProps {
  aiHelp: AiHelp | undefined;
  question: Question;
  onAnswerQuestion: (questionId: string) => void;
  onGetAIHelp: HandleGetHelpFunction;
}

export function QuestionItem({
  aiHelp,
  question,
  onAnswerQuestion,
  onGetAIHelp,
}: Readonly<QuestionItemProps>) {
  return (
    <li className="flex flex-col border-b border-gray-100 p-2 last:border-b-0">
      <div className="flex items-center justify-between space-x-2">
        <div className="flex-grow-0">
          <Button
            size="sm"
            variant={"ghost"}
            className="px-2"
            onClick={() => onAnswerQuestion(question.id)}
            disabled={question.isAnswered}
          >
            {question.isAnswered ? (
              <CheckCircle size={16} />
            ) : (
              <MessageCircleQuestion size={16} />
            )}
          </Button>
        </div>
        <div className="flex-grow font-semibold">
          <div>{question.question}</div>
        </div>

        <div className="flex-grow-0 pr-2">
          <Button
            size="sm"
            className="px-2"
            variant="outline"
            onClick={() =>
              onGetAIHelp({
                detectedQuestion: question,
              })
            }
          >
            <Sparkles size={16} className="mr-1" />
          </Button>
        </div>
      </div>
      {/* <div className="text-sm text-gray-600 px-2">{question.context}</div> */}
      {aiHelp && (
        <div className="px-2 text-sm text-gray-600">
          <ReactMarkdown className="prose prose-sm max-w-none dark:prose-invert">
            {aiHelp.answer}
          </ReactMarkdown>
        </div>
      )}
    </li>
  );
}
